import { ReactNode } from 'react';
import { CSS } from '@dnd-kit/utilities';
import { getId } from '@app/components/contract-boxes/generic-box-helpers';
import { useSortable } from '@dnd-kit/sortable';
import clsx from 'clsx';

import { useBoxPermissionProps } from '@app/contexts/box-permission-props';

import SmallDragHandlerIcon from '@app/components/icons/small-drag-handler';

import style from './drag-control-item.module.scss';

type Props = {
  children: ReactNode;
  index: number;
  item: object;
};

const DragControlItem = (props: Props) => {
  const { isAllowedToReorderBoxData } = useBoxPermissionProps();

  const { item } = props;
  const id = getId(item);

  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id,
    animateLayoutChanges: () => false,
  });
  const dragWrapperClasses = clsx(style.DragWrapper, {
    [style.IsDragging]: isDragging,
    [style.Disabled]: !isAllowedToReorderBoxData,
  });

  return (
    <div
      className={dragWrapperClasses}
      ref={setNodeRef}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
    >
      <div
        {...attributes}
        {...listeners}
        className={style.DragHandlerWrapper}
      >
        <div className={style.IconWrapper}>
          <div className={style.Icon}>
            <SmallDragHandlerIcon
              width="10px"
              height="10px"
            />
          </div>
        </div>
      </div>
      {props.children}
    </div>
  );
};

export default DragControlItem;
